import logger from '../utils/logger';

class LoadingService {
  constructor() {
    this.listeners = new Set();
    this.messages = [];
    this.progress = null;
    this.isVisible = false;
  }

  // Add a listener for loading updates
  addListener(callback) {
    this.listeners.add(callback);
    return () => this.listeners.delete(callback);
  }

  // Notify all listeners of changes
  notifyListeners() {
    this.listeners.forEach((callback) => {
      callback({
        isVisible: this.isVisible,
        progress: this.progress,
        messages: this.messages,
      });
    });
  }

  // Show the loading panel
  show() {
    this.isVisible = true;
    this.notifyListeners();
  }

  // Hide the loading panel
  hide() {
    this.isVisible = false;
    this.notifyListeners();
  }

  // Update progress
  updateProgress(progress) {
    this.progress = progress;
    this.isVisible = true;
    this.notifyListeners();
  }

  // Add a message
  addMessage(text, type = 'info') {
    const message = {
      text,
      type,
      timestamp: new Date().toISOString(),
    };

    this.messages.push(message);

    // Keep only the last 50 messages
    if (this.messages.length > 50) {
      this.messages = this.messages.slice(-50);
    }

    this.isVisible = true;
    this.notifyListeners();
  }

  // Add success message
  addSuccess(text) {
    this.addMessage(text, 'success');
  }

  // Add error message
  addError(text) {
    this.addMessage(text, 'error');
  }

  // Add warning message
  addWarning(text) {
    this.addMessage(text, 'warning');
  }

  // Add info message
  addInfo(text) {
    this.addMessage(text, 'info');
  }

  // Clear all messages
  clearMessages() {
    this.messages = [];
    this.notifyListeners();
  }

  // Reset everything
  reset() {
    this.messages = [];
    this.progress = null;
    this.isVisible = false;
    this.notifyListeners();
  }

  // Get current state
  getState() {
    return {
      isVisible: this.isVisible,
      progress: this.progress,
      messages: this.messages,
    };
  }
}

// Create a singleton instance
const loadingService = new LoadingService();

// Console hijacking DISABLED to reduce noise - debug logs were excessive
// Original console methods preserved but no longer intercepted
const originalConsoleLog = console.log;
const originalConsoleError = console.error;
const originalConsoleWarn = console.warn;
const originalConsoleInfo = console.info;

// Only restore originals, no more hijacking
// console.log = originalConsoleLog;
// console.error = originalConsoleError;
// console.warn = originalConsoleWarn;
// console.info = originalConsoleInfo;

export default loadingService;
